import { Coordinates } from "@hermes/api-model-common";
import { Shop } from "@hermes/api-model-shop";
import { isChina, Locale } from "@hermes/locale";

export const getCoordinatesBasedOnLocale = (
    shop: Shop,
    locale: Locale,
): Coordinates =>
    isChina(locale) ? shop.baiduGeoCoordinates : shop.geoCoordinates;
